import useMobile from "customHooks/useMobile";
import CustomContentLoader from "../ReuseableCompos/CustomContentLoader";

const CommentSkeleton = () => {
  const isMobile = useMobile("md");

  return (
    <CustomContentLoader viewBox={`0 0 ${!isMobile ? "8" : "3"}00 75`}>
      <rect x="6" y="2" rx="10" ry="10" width="34" height="30" />
      <rect x="43" y="5" rx="4" ry="4" width="81" height="10" />
      <rect x="44" y="21" rx="3" ry="3" width="62" height="9" />
      <rect x="6" y="41" rx="4" ry="4" width="290" height="22" />
    </CustomContentLoader>
  );
};

export default CommentSkeleton;
